import React from 'react';
import Avatar from 'material-ui/Avatar';
import {urlPrefix} from 'engine/dataServices';

const UserCell = ({user}) => {
    const {id, title, image, desc} = user;
    let avatar = (image) ? urlPrefix + image : require('assets/Images/TolitonAvatar.png');

    return (

        <div className="user-profile d-flex flex-row align-items-center">
            <Avatar
                alt={title}
                src={avatar}
                className="user-avatar"
            />
            <div className="user-detail">
                <h4 className="text-muted text-uppercase mb-2 text-secondary">
                    {title}
                </h4>
                <h5>
                    {desc}
                </h5>
            </div>
        </div>

    );
};

export default UserCell;



// WEBPACK FOOTER //
// ./components/toliton/desktop/producers/UserCell.js